import { makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Button, Dialog, DialogTitle, IconButton } from '@mui/material';
import { FeedbackColumnDefs, WhereUsedColumnDefs } from 'modules/constants/QuestionBankConstants';
import AddQuestion from 'modules/dashboard/AddQuestion';
import { apiPaths, get } from 'modules/platform-components/api-integration-util';
import QuestionViewer from 'modules/platform-components/question-viewer/QuestionViewer';
import { getUserDetails } from 'modules/platform-components/utils/shared-data.service';
import React, { useCallback, useEffect, useRef, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  editButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(7),
  },
}));

function QuestionViewModal(props) {
  const { open, setId, handleClose, QBCount, prevQuestion, nxtQuestion, questionData, selectedQuestion, isEditEnabled, selectedQuestionEditable } = props;

    // Add isEditing state
    const [isEditing, setIsEditing] = useState(selectedQuestionEditable);

  // Reset edit mode when a different question is selected so edit state from
  // Q1 doesn't bleed into Q2 if modal stays mounted across row clicks.
  useEffect(() => {
    setIsEditing(selectedQuestionEditable);
  }, [selectedQuestion, selectedQuestionEditable]);

  // Clear stale 'routeFrom' set by an earlier Dashboard navigation so the
  // QuestionViewer inside this modal doesn't render Dashboard-style swapped
  // Prev/Next labels.
  useEffect(() => {
    if (open) {
      sessionStorage.removeItem('routeFrom');
    }
  }, [open]);

  const classes = useStyles();
  let [whereUsedPopupgridOptions, setwhereUsedPopupgridOptions] = useState({});
  let [feedbackPopupgridOptions, setFeedbackPopupgridOptions] = useState({});
  let [showWhereUsedGrid, setShowWhereUsedGrid] = useState(true);
  let [feedbackGrid, setFeedbackUsedGrid] = useState(true);
  let [whereUsedQuestionId, setWhereUsedQuestionId] = useState(null);
  let whereUsedGridApi = useRef();
  let feedbackGridApi = useRef();

  const handleEdit = () => {
    setIsEditing(true);
  };

  let plotWhereUsedGrid = useCallback((rowData) => {
    whereUsedPopupgridOptions.pagination = true;
    whereUsedPopupgridOptions.columnDefs = WhereUsedColumnDefs;
    whereUsedPopupgridOptions.rowData = rowData;
    setTimeout(() => whereUsedGridApi?.current?.setRowData(rowData));
    setwhereUsedPopupgridOptions(whereUsedPopupgridOptions);
    setShowWhereUsedGrid(true);
  }, [whereUsedPopupgridOptions]);

  let onWhereUsedButtonClick = useCallback(() => {
    console.log('selectedQuestion: ', selectedQuestion);
    if (selectedQuestion && +selectedQuestion !== 0) {
      setShowWhereUsedGrid(false);
      setFeedbackUsedGrid(false);
      setWhereUsedQuestionId(selectedQuestion);
      get(`${apiPaths.getQuestionHistory}/${selectedQuestion}`, {
        tenantId: getUserDetails().tenantId,
      }).then((res) => {
        plotWhereUsedGrid(res?.result);
      });
      get(`${apiPaths.getQuestionFeedbackById}?libTypeList=TEST&libTypeList=QBANK&questionId=${selectedQuestion}`, {
        tenantId: getUserDetails().tenantId,
      }).then((res) => {
        plotFeedbackGrid(res?.result);
      });
    }
  }, [plotWhereUsedGrid, selectedQuestion]);

  useEffect(() => {
    onWhereUsedButtonClick(+selectedQuestion);
  }, [onWhereUsedButtonClick, selectedQuestion]);

  

  const plotFeedbackGrid = (rowData) => {
    const feedbackPopupgridOptions = {};
    feedbackPopupgridOptions.pagination = true;
    feedbackPopupgridOptions.columnDefs = FeedbackColumnDefs;
    feedbackPopupgridOptions.rowData = rowData;

    setTimeout(() => feedbackGridApi?.current?.setRowData(rowData));

    setFeedbackPopupgridOptions(feedbackPopupgridOptions);
    setFeedbackUsedGrid(true);
  };

  const renderDialogContent = () => {
    if (isEditing) {
      return (
        <div style={{ padding: '15px' }}>
          <AddQuestion
            QBEdit={true}
            qbId={selectedQuestion}
            onExitEdit={() => setIsEditing(false)}
          />
        </div>
      );
    } else {
      return (
        <QuestionViewer
          whereUsedPopupgridOptions={whereUsedPopupgridOptions}
          feedbackPopupgridOptions={feedbackPopupgridOptions}
          prevQuestion={prevQuestion}
          nxtQuestion={nxtQuestion}
          {...questionData}
          count={QBCount}
          showWhereUsedGrid={showWhereUsedGrid}
          feedbackGrid={feedbackGrid}
          setId={setId}
        />
      );
    }
  };

  return (
    <div>
      <Dialog maxWidth="xl" fullWidth maxHeight="lg" open={open} onClose={handleClose}>
        <DialogTitle>
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
          {isEditEnabled && !isEditing && (
            <Button aria-label="edit" variant="outlined" className={classes.editButton} onClick={handleEdit}>
              Edit
            </Button>
          )}
        </DialogTitle>
        {renderDialogContent()}
      </Dialog>
    </div>
  );
}

export default QuestionViewModal;
